import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {Table, Thead, Tr, Th, Td} from './Table';
import TextField from 'material-ui/TextField';

// import Pagination from './Pagination';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import Pagination from 'react-js-pagination';
import config from '../../config';

const Wrapper = styled.div``;
const ScrollWrapper = styled.div`
  overflow: scroll;
  width: ${props => (props.windowWidth ? props.windowWidth - 40 + 'px' : '100%')};
`;

const PaginationHolder = styled.div`
  text-align: right;
`;

const SearchHolder = styled.div`
  margin-bottom: 20px;
  float: right;
  width: 300px;
`;
const Tds = styled(Td)`
  height: 65px;
  padding: 5px;
  overflow: hidden;
  box-sizing: border-box;
  p {
    margin: 0;
  }
  .show {
    opacity: 1 !important;
  }
`;
class EntityTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: config.getCurrentPage(props.tableConfig.localStorageId),
      filterVal: '',
      filteredRows: props.data ? props.data : [],
      width: window.innerWidth,
    };
  }

  _filterRows = (filterVal, rows) => {
    if (!rows) {
      rows = [];
    }
    let regex = new RegExp(filterVal, 'i');
    let {filterString} = this.props.tableConfig;
    let filtered = rows.filter(entity => {
      let entityText = filterString ? filterString(entity) : Object.values(entity).toString();
      return entityText.search(regex) > -1;
    });
    this.setState({filteredRows: filtered, filterVal: filterVal});
  };

  _filter = event => {
    event.preventDefault();
    this.setState({currentPage: 1});
    this._filterRows(event.target.value, this.props.data);
  };

  componentDidMount() {
    this._updateDimensions();
    window.addEventListener('resize', this._updateDimensions);
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions);
  }

  componentWillReceiveProps(newProps) {
    this._updateRows(newProps.data);
  }
  _updateDimensions = () => {
    this.setState({width: window.innerWidth});
  };
  _updateRows = data => {
    if (!data) {
      data = [];
    }
    this._filterRows(this.state.filterVal, data);
  };

  _paginationChange = page => {
    this.setState({currentPage: page});
    if (this.props.tableConfig.localStorageId) {
      config.saveCurrentPage(this.props.tableConfig.localStorageId, page);
    }
  };
  render() {
    let {tableConfig, totalRows, showFilter, loading, hiddenColumns} = this.props;
    let pagination;
    let paginationRows = totalRows;
    if (this.state.totalRows == null) {
      paginationRows = this.state.filteredRows.length;
    }

    if (paginationRows > tableConfig.maxRows) {
      pagination = (
        <PaginationHolder>
          <Pagination
            activePage={this.state.currentPage}
            itemsCountPerPage={tableConfig.maxRows}
            totalItemsCount={paginationRows}
            pageRangeDisplayed={5}
            onChange={this._paginationChange}
          />
        </PaginationHolder>
      );
    }
    let search;
    if (showFilter) {
      search = (
        <SearchHolder>
          <TextField
            type="text"
            name="search"
            placeholder={'Schnellfilter'}
            onChange={this._filter}
            value={this.state.filterVal}
          />
        </SearchHolder>
      );
    }
    let page = this.state.currentPage;

    if (loading) return <div>Daten werden geladen...</div>;

    return (
      <Wrapper>
        <ReactTooltip />
        {search}
        <ScrollWrapper windowWidth={this.state.width}>
          <Table>
            <Thead>
              <Tr>
                {tableConfig.cols.map((conf, idx) => {
                  if (hiddenColumns.includes(conf.id)) {
                    return null;
                  }
                  if (!conf.header || conf.header === '') {
                    return (
                      <Th customWidth={conf.width} key={idx}>
                        &nbsp;
                      </Th>
                    );
                  } else {
                    return (
                      <Th customWidth={conf.width} key={idx}>
                        {conf.header}
                      </Th>
                    );
                  }
                })}
              </Tr>
            </Thead>
            <tbody>
              {this.state.filteredRows.map((item, idx) => {
                if (idx >= (page - 1) * tableConfig.maxRows && idx < page * tableConfig.maxRows) {
                  return (
                    <Tr key={idx} idx={idx}>
                      {tableConfig.cols.map((conf, colIdx) => {
                        if (hiddenColumns.includes(conf.id)) {
                          return null;
                        }
                        let value;
                        if (conf.valueKey === '*') {
                          value = item;
                        } else {
                          value = item[conf.valueKey];
                        }

                        if (conf.tooltip) {
                          return (
                            <Tds key={idx + '_' + colIdx} hasMore={conf.hasMore}>
                              <p data-tip={conf.tooltip}>{conf.method(value)}</p>
                            </Tds>
                          );
                        }
                        if (conf.tooltipMethod) {
                          return (
                            <Tds key={idx + '_' + colIdx} hasMore={conf.hasMore}>
                              <p data-tip data-for={`${idx}_${colIdx}`}>
                                {conf.method(value)}
                              </p>
                              <ReactTooltip id={`${idx}_${colIdx}`}>{conf.tooltipMethod(value)}</ReactTooltip>
                            </Tds>
                          );
                        }
                        return (
                          <Tds key={idx + '_' + colIdx} hasMore={conf.hasMore}>
                            {conf.method(value)}
                          </Tds>
                        );
                      })}
                    </Tr>
                  );
                }
                return null;
              })}
            </tbody>
          </Table>
        </ScrollWrapper>
        {pagination}
      </Wrapper>
    );
  }
}

EntityTable.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  tableConfig: PropTypes.object.isRequired,
  hiddenColumns: PropTypes.array,
  msg: PropTypes.string.isRequired,
};

EntityTable.defaultProps = {
  loading: false,
  hiddenColumns: [],
};

export default EntityTable;



// WEBPACK FOOTER //
// ./src/components/table/EntityTable.js